"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIGRATION_007 = void 0;
/**
 * Migration 007 (server only): Postgres-blob file storage.
 *
 * Adds `omni_file_blobs` keyed by `omni_files.id` with a single `content`
 * BYTEA column. Separating metadata (omni_files, small rows) from bytes
 * (omni_file_blobs, large rows) keeps `SELECT * FROM omni_files` fast.
 *
 * `ON DELETE CASCADE` means a row deleted from omni_files drops its bytes
 * automatically — callers never need a two-step delete.
 */
const MIGRATION_007_SQL = `\
CREATE TABLE IF NOT EXISTS omni_file_blobs (
  file_id TEXT PRIMARY KEY REFERENCES omni_files(id) ON DELETE CASCADE,
  content BYTEA NOT NULL
);
`;
exports.MIGRATION_007 = {
    id: '007_file_blobs',
    version: 7,
    name: 'postgres-blob file storage (omni_file_blobs)',
    side: 'server',
    sql: MIGRATION_007_SQL,
};
//# sourceMappingURL=007_file_blobs.js.map